import React, { useCallback, useEffect, useRef, useState } from 'react';
import { setChangeReasonPrompt } from '../services/api';
import ReasonDialog from './ProjectPage/roadmap/ReasonDialog';

// Fenêtre de motif de toute l'appli : quand le serveur exige un motif (roadmap ou budget tenus par un rôle) pour une
// requête partie sans (pilotage, ancienne fiche…), apiService l'ouvre ici puis renvoie la requête avec le motif.

const ChangeReasonHost = () => {
  const [request, setRequest] = useState(null);
  const answer = useRef(null);
  useEffect(() => {
    setChangeReasonPrompt((info) => new Promise((resolve) => {
      answer.current?.(null);
      answer.current = resolve;
      setRequest(info);
    }));
    return () => setChangeReasonPrompt(null);
  }, []);
  const onAnswer = useCallback((value) => {
    const resolve = answer.current;
    answer.current = null;
    setRequest(null);
    resolve?.(value);
  }, []);
  return <ReasonDialog request={request} onAnswer={onAnswer} />;
};

export default ChangeReasonHost;
